import { useState } from "react";
import { getVisibility } from "./get-visibility";
import { LinePosition } from "./types";

export function useVisibility(sections: Array<unknown>) {
  const [visibleTopsIdxs, setVisibleTopsIdxs] = useState<Map<number, LinePosition>>(new Map());
  const [visibleBottomsIdxs, setVisibleBottomsIdxs] = useState<Map<number, LinePosition>>(new Map());

  const onVisibilityChange = (idx: number) => (e: "top" | "bottom", state: LinePosition) => {
    if (e === "top") {
      setVisibleTopsIdxs(m => {
        let ret = new Map(m);
        ret.set(idx, state);
        return ret;
      });
    } else {
      setVisibleBottomsIdxs(m => {
        let ret = new Map(m);
        ret.set(idx, state);
        return ret;
      });
    }
  };

  const visibility = getVisibility(sections, visibleTopsIdxs, visibleBottomsIdxs);

  return { onVisibilityChange, visibility };
}
